import { isAxiosError } from "axios";

/**
 * Returns the error message from an error object, with details that can be useful for developers.
 * To be used internally only.
 *
 * @param error - The error to get the message from
 * @returns The error message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessageInternal(error: any): string {
  let errorMessage =
    error instanceof Error || (typeof error === "object" && "message" in error)
      ? error.message
      : String(error);
  if (isAxiosError(error)) {
    const message = error.response?.data.detail;
    if (typeof message === "string") errorMessage = message;
  }
  return errorMessage;
}
